import React from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaPinterest,
  FaTiktok,
  FaTwitter,
  FaYoast,
  FaYoutube,
} from "react-icons/fa";

function Footer() {
  const { config } = useSiteConfig();

  // Scroll to Top Function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer className="skin-footer">
        {/* Background Decor (Watermark) */}
       

        <div className="container position-relative z-2">
          <div className="row g-4 justify-content-between">
            {/* 2. Column: Mission Statement */}
            <div className="col-lg-4 col-md-6 mb-4 mb-md-0">
              <h5 className="footer-head">Axiom Global</h5>
              <p className="footer-desc">{config?.shortDescription}</p>
              <div className="footer-socials">
                {config?.socialMedia?.facebook && (
                  <Link
                    to={config?.socialMedia?.facebook}
                    target="_blank"
                    className="social-link"
                  >
                    <FaFacebook />
                  </Link>
                )}
                {config?.socialMedia?.instagram && (
                  <Link
                    to={config?.socialMedia?.instagram}
                    target="_blank"
                    className="social-link"
                  >
                    <FaInstagram />
                  </Link>
                )}
                {config?.socialMedia?.twitter && (
                  <Link
                    to={config?.socialMedia?.twitter}
                    target="_blank"
                    className="social-link"
                  >
                    <FaTwitter />
                  </Link>
                )}
                {config?.socialMedia?.youtube && (
                  <Link
                    to={config?.socialMedia?.youtube}
                    target="_blank"
                    className="social-link"
                  >
                    {" "}
                    <FaYoast />
                  </Link>
                )}
              </div>
            </div>

            {/* 3. Column: Shop Links */}
            <div className="col-lg-2 col-md-3 col-6">
              <h5 className="footer-head">Quick Links</h5>
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/shop">Shop</Link>
                </li>
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
              </ul>
            </div>

            {/* 4. Column: Support Links */}
            <div className="col-lg-2 col-md-3 col-6">
              <h5 className="footer-head">Customer Care</h5>
              <ul className="footer-links">
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms & Conditions</Link>
                </li>
                
              </ul>
            </div>

            {/* 5. Column: Newsletter (Mini) */}
            <div className="col-lg-3 col-md-12">
              <div className="newsletter-box">
                <h5 className="footer-head">Stay Connected</h5>

                <div className="footer-socials">
                 
                    <Link
                      to="#"
                      target="_blank"
                      className="social-link"
                    >
                      <FaFacebook />
                    </Link>
                
                    <Link
                      to="#"
                      target="_blank"
                      className="social-link"
                    >
                      <FaInstagram />
                    </Link>
         
                    <Link
                      to="#"
                      target="_blank"
                      className="social-link"
                    >
                      <FaLinkedin />
                    </Link>
                    
                    <Link
                      to="#"
                      target="_blank"
                      className="social-link"
                    >
                      <FaYoutube />
                    </Link>
            
                    
                </div>
              </div>
            </div>
          </div>

          <div className="footer-divider"></div>

          {/* 6. Bottom Bar */}
          <div className="row align-items-center bottom-bar">
            <div className="col-md-6 text-center text-md-start">
               <p className="copyright">
              All Rights Reserved © 2026 {" "}    AXIOM GLOBAL  | Designed & Developed by
              <a
              href="https://axesell.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
               {" "}  Axesell
            </a>
        
             
            </p>
             
            </div>
            <div className="col-md-6 text-center text-md-end">
              <div className="legal-links">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <span className="separator">•</span>
                <Link to="/terms-and-conditions">Terms of Service</Link>
              </div>
            </div>
          </div>
        </div>

        {/* Unique "Leaf" Scroll to Top Button */}
        <button
          onClick={scrollToTop}
          className="scroll-leaf-btn"
          aria-label="Scroll to top"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 19V5M12 5L5 12M12 5L19 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </footer>
    </>
  );
}

export default Footer;
